"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsArray = exports.isArray = void 0;
const isArray_1 = __importDefault(require("lodash/isArray"));
const isArrayLike_1 = __importDefault(require("lodash/isArrayLike"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const isNil_1 = __importDefault(require("lodash/isNil"));
const mol_validator_utils_1 = require("../utils/mol-validator-utils");
const Exists_1 = require("./Exists");
// eslint-disable-next-line sonarjs/cognitive-complexity
async function isArray(value, args, constraints) {
    const existsResults = await (0, Exists_1.exists)(value, args, {
        isOptional: constraints === null || constraints === void 0 ? void 0 : constraints.isOptional,
        if: constraints === null || constraints === void 0 ? void 0 : constraints.if,
        allowEmptyString: true,
    });
    if (existsResults.pass === false || existsResults.skipped) {
        return existsResults;
    }
    if (constraints === null || constraints === void 0 ? void 0 : constraints.allowArrayLike) {
        if (!(0, isArrayLike_1.default)(value)) {
            return { pass: false, message: `should be array-like` };
        }
    }
    else {
        if (!(0, isArray_1.default)(value)) {
            return { pass: false, message: `should be an array` };
        }
    }
    if ((constraints === null || constraints === void 0 ? void 0 : constraints.minLength) > 0 && (0, isEmpty_1.default)(value)) {
        return { pass: false, message: `should not be empty` };
    }
    if ((!!(constraints === null || constraints === void 0 ? void 0 : constraints.minLength) && value.length < constraints.minLength) ||
        (!!(constraints === null || constraints === void 0 ? void 0 : constraints.maxLength) && value.length > constraints.maxLength)) {
        let message = `should have length between ${constraints.minLength} and ${constraints.maxLength}`;
        message = (0, isNil_1.default)(constraints === null || constraints === void 0 ? void 0 : constraints.minLength)
            ? `should have length less than or equals to ${constraints.maxLength}`
            : message;
        message = (0, isNil_1.default)(constraints === null || constraints === void 0 ? void 0 : constraints.maxLength)
            ? `should have length more than or equals to ${constraints.minLength}`
            : message;
        return { pass: false, message };
    }
    if (constraints === null || constraints === void 0 ? void 0 : constraints.isIn) {
        const allValid = value.every((checkValue) => constraints.isIn.includes(checkValue));
        if (!allValid) {
            return { pass: false, message: `should be of the following values: ${constraints.isIn.join(",")}` };
        }
    }
    return { pass: true };
}
exports.isArray = isArray;
/**
 * Validates that the value is a valid array
 * NOTE: Differs from the class-validator version by allowing additional constraints
 */
function IsArray(constraints, options) {
    return (0, mol_validator_utils_1.registerValidatorDecorator)({
        name: "IsArray",
        defaultMessage: "should be a valid array",
        options,
        constraints,
        validateFn: isArray,
    });
}
exports.IsArray = IsArray;
//# sourceMappingURL=IsArray.js.map